import { Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CmsTaxonomyGeneral } from '@fcom/core-api';
import { LanguageService } from '@fcom/ui-translate';

import { ElementTypes } from '../../interfaces';
import { NavigationMenuService } from '../../services';

@Component({
  selector: 'fin-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  @Input()
  content$: Observable<any>;

  readonly isVisible$: Observable<boolean>;
  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  copyrightBanner$: Observable<Object>;
  year: number = new Date().getFullYear();
  readonly menuItems$: Observable<any>;
  public readonly ElementTypes = ElementTypes;

  constructor(
    private languageService: LanguageService,
    public navigationMenuService: NavigationMenuService
  ) {
    this.menuItems$ = this.navigationMenuService.menuItems$.pipe(map((data) => data.bottom));
    this.isVisible$ = this.navigationMenuService.isFooterVisible$;
  }
  ngOnInit(): void {
    this.copyrightBanner$ = this.languageService.translate('copyrightBanner');
  }
}
